/*
 * Rippin Moto: Help me choose guide.
 * Behaviour copied from recommend() in parts/04-07-ui.js:
 *   - Street or supermoto always resolves to the Supermoto family (never the
 *     off-road family, never the custom builder).
 *   - "Both" is not in the original prototype (which only had dirt/street).
 *     Treated the same as Off-road here since it is the more versatile
 *     wheelset for mixed riding; flagged as an open question for Peter in
 *     HANDOFF.md.
 *   - Ready-to-Ride toggles the family from wheels-only to its RTR sibling.
 * Prices are fetched live from /products/<handle>.js rather than baked into
 * the page, per COMMON.md: "figures move... verify against the live site."
 */
(function () {
  var root = document.querySelector('rm-guide.rm-guide');
  if (!root) return;

  // The handle-map script sits after the inner <section class="rm-guide-section">
  // and inside Savor's outer .shopify-section wrapper, so scope the lookup to
  // the wrapper (and fall back to the document) rather than to closest('section').
  var scope = root.closest('.shopify-section') || document;
  var handlesEl = scope.querySelector('script[data-rm-guide-handles]');
  var HANDLES = {};
  try {
    HANDLES = JSON.parse((handlesEl && handlesEl.textContent) || '{}');
  } catch (e) {
    HANDLES = {};
  }

  var state = { bike: null, where: 'dirt', tires: 'no' };

  try {
    var saved = window.localStorage.getItem('rm_bike');
    if (saved) state.bike = saved;
  } catch (e) {}

  var bikeSelect = root.querySelector('[data-rm-bike-select]');
  var whereButtons = root.querySelectorAll('[data-where]');
  var tireButtons = root.querySelectorAll('[data-tires]');
  var resultEl = root.querySelector('[data-rm-result]');
  var placeholderEl = root.querySelector('[data-rm-placeholder]');
  var recoImg = root.querySelector('[data-rm-reco-img]');
  var recoEyebrow = root.querySelector('[data-rm-reco-eyebrow]');
  var recoTitle = root.querySelector('[data-rm-reco-title]');
  var recoPrice = root.querySelector('[data-rm-reco-price]');
  var recoLink = root.querySelector('[data-rm-reco-link]');
  var noteEl = root.querySelector('[data-rm-note]');
  var noteText = root.querySelector('[data-rm-note-text]');

  var FAMILY_TITLE = {
    offroad: 'Blackline Off-Road Wheelset',
    supermoto: 'Blackline Supermoto Wheelset',
    rtror: 'Blackline Off-Road Wheelset Ready-to-Ride',
    rtrsm: 'Blackline Supermoto Wheelset Ready-to-Ride'
  };

  function money(n) {
    return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  function setPressed(buttons, matchAttr, value) {
    buttons.forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset[matchAttr] === value ? 'true' : 'false');
    });
  }

  function familyKey() {
    // "both" is treated the same as "dirt" (off-road); see the note above.
    var street = state.where === 'street';
    var rtr = state.tires === 'yes';
    var setup = street ? 'supermoto' : 'offroad';
    return rtr ? (setup === 'supermoto' ? 'rtrsm' : 'rtror') : (setup === 'supermoto' ? 'supermoto' : 'offroad');
  }

  /* The placeholder doubles as the unsupported-model message (copy brief H04). */
  var placeholderText = root.querySelector('[data-rm-placeholder-text]');
  var placeholderDefault = placeholderText ? placeholderText.textContent : '';
  function setPlaceholder(unsupported) {
    if (!placeholderText) return;
    placeholderText.textContent = unsupported
      ? "We don't have a confirmed wheelset option listed for this bike. Contact us to discuss your setup."
      : placeholderDefault;
  }

  function render() {
    if (bikeSelect) bikeSelect.value = state.bike && bikeSelect.querySelector('option[value="' + state.bike + '"]') ? state.bike : '';
    setPressed(whereButtons, 'where', state.where);
    setPressed(tireButtons, 'tires', state.tires);

    if (!state.bike || !HANDLES[state.bike]) {
      resultEl.hidden = true;
      placeholderEl.hidden = false;
      setPlaceholder(!!state.bike);
      return;
    }
    placeholderEl.hidden = true;
    resultEl.hidden = false;

    var fam = familyKey();
    var entry = HANDLES[state.bike][fam];
    // The handle map stores a plain handle string. An object with a .handle is
    // accepted too so the map can gain per-family extras later.
    var handle = typeof entry === 'string' ? entry : (entry && entry.handle);
    if (!handle) {
      resultEl.hidden = true;
      placeholderEl.hidden = false;
      setPlaceholder(true);
      return;
    }

    var street = state.where === 'street';
    recoEyebrow.textContent = street
      ? 'Supermoto setup, sizes listed for your bike'
      : 'Off-road setup, sizes listed for your bike';
    recoTitle.textContent = FAMILY_TITLE[fam];
    recoPrice.textContent = 'Loading price...';
    recoLink.href = '/products/' + handle;
    recoImg.style.backgroundImage = '';

    noteEl.hidden = false;
    noteText.textContent =
      (state.where === 'both'
        ? 'For mixed riding we show the off-road set. Choose Supermoto if you mostly ride pavement. '
        : '') +
      'Starting price shown. Your final price depends on wheel size, finish, and tire selection.';

    fetchProduct(handle);
  }

  var cache = {};
  function fetchProduct(handle) {
    if (cache[handle]) {
      applyProduct(handle, cache[handle]);
      return;
    }
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) {
          recoPrice.textContent = 'Ask us for this combination';
          return;
        }
        cache[handle] = data;
        applyProduct(handle, data);
      })
      .catch(function () {
        recoPrice.textContent = 'Ask us for this combination';
      });
  }

  function applyProduct(handle, data) {
    if (!resultEl.hidden && recoLink.href.indexOf(handle) === -1) return;
    if (data.title) recoTitle.textContent = data.title;
    var minPrice = data.price_min != null ? data.price_min / 100 : data.price / 100;
    recoPrice.textContent = 'Starting price: ' + money(minPrice);
    var img = (data.featured_image || (data.images && data.images[0]));
    if (img) {
      var url = typeof img === 'string' ? img : img.src;
      if (url && url.indexOf('//') === 0) url = 'https:' + url;
      if (url) recoImg.style.backgroundImage = "url('" + url + "')";
    }
  }

  if (bikeSelect) {
    bikeSelect.addEventListener('change', function () {
      state.bike = bikeSelect.value || null;
      try {
        if (state.bike) window.localStorage.setItem('rm_bike', state.bike);
        else window.localStorage.removeItem('rm_bike');
      } catch (e) {}
      document.dispatchEvent(new CustomEvent('rm:bike-change', { detail: { bike: state.bike, handle: state.bike } }));
      render();
    });
  }

  document.addEventListener('rm:bike-change', function (ev) {
    var next = ev && ev.detail && ev.detail.handle;
    if (typeof next === 'undefined' || next === state.bike) return;
    state.bike = next || null;
    render();
  });

  whereButtons.forEach(function (b) {
    b.addEventListener('click', function () {
      state.where = b.dataset.where;
      render();
    });
  });

  tireButtons.forEach(function (b) {
    b.addEventListener('click', function () {
      state.tires = b.dataset.tires;
      render();
    });
  });

  render();
})();
